// src/components/pages/Movimento/CreateOrEdit/modules/useCabecalhoModule.js
import { useCallback } from 'react';

import { formatarNumeroDecimal } from '../../../../../utils/masks';

import * as PessoaAPI from '../../../../../api/pessoa';

import { handleParceiroLookup, handleColaboradorLookup, handleParceiroImovelLookup } from '../shared/pessoaLookup';

export function useCabecalhoModule(params) {
    const {
        dados,
        setDados,
        profile,
        dataPlantao,

        setParceiro,
        onItensXmlLoaded,
        setFlashMessage,
    } = params;
    // helpers
    const setRemote = useCallback((obj) => {
        setDados((prev) => ({
            ...prev,
            ...(obj || {}),
        }));
    }, []);

    const clear = useCallback(() => {
        setDados((prev) => ({
            ...prev,
            numero: '',
            parceiroId: null,
            colaboradorId: null,
            centroCustoId: null,
            almoxarifadoId: prev.almoxarifadoId ?? null,
        }));
    }, []);

    const aplicarDocumentoFiscal = useCallback(
        async (response) => {
            try {
                if (response?.type === 'error' && response?.message) {
                    if (typeof setFlashMessage === 'function') {
                        setFlashMessage(
                            `${response.message}\nNão foi possível carregar o XML`,

                            'error',

                            8
                        );
                    }

                    return false;
                }

                if (response?.type !== 'success' || !response?.data) {
                    return false;
                }

                const dadosNfe = response.data.nfe || {};

                const chave = String(response.data.chave || dadosNfe.chave || dadosNfe.chNFe || '').replace(/\D/g, '');

                if (chave.length !== 44) {
                    if (typeof setFlashMessage === 'function') {
                        setFlashMessage(
                            'A resposta fiscal não possui uma chave válida.',

                            'error'
                        );
                    }

                    return false;
                }

                const valoresNfe = dadosNfe.total || {};

                const transporte = dadosNfe.transporte || {};

                const dadosPreNota = {
                    ...(response.data.preNota || {}),

                    empresaId: dados?.empresaId || response.data?.preNota?.empresa?.id || null,
                };

                const dadosMovimento = dadosPreNota.movimento || {};

                const cobranca = dadosNfe.cobranca || {};

                const emitente = dadosNfe.emitente || {};

                const destinatario = dadosNfe.destinatario || {};

                const endEmit = emitente.endereco || {};

                const endDest = destinatario.endereco || {};

                const empresa = dadosPreNota.empresa || {};

                const parceiro = dadosPreNota.parceiro || {};

                if (parceiro?.id && typeof setParceiro === 'function') {
                    setParceiro(parceiro);
                }

                console.info('[Movimento/XML] Documento fiscal aplicado:', {
                    nfe: dadosNfe,
                    valoresNfe,
                    dadosPreNota,
                    cobranca,
                    transporte,
                });

                setDados((prev) => ({
                    ...prev,

                    nfeChaveConsultada: chave,
                    documentoFiscalDistribuidoId:
                        response?.data?.documentoOperacional?.id || prev.documentoFiscalDistribuidoId || null,
                    gravarPreNotaXml: dadosNfe?.gravarPreNotaXml,
                    empresaId: empresa?.id || prev.empresaId || null,

                    data: dadosNfe.dataEmissao || dadosMovimento.data || prev.data || null,
                    chNFe: chave,
                    nNF: dadosNfe.numero || dadosMovimento.numero || prev.numero || '',
                    numero: dadosNfe.numero || dadosMovimento.numero || prev.numero || '',
                    serie: dadosNfe.serie || dadosMovimento.serie || prev.serie || '',
                    mod: dadosNfe.mod || dadosMovimento.mod || prev.mod || '',
                    tpNF: dadosNfe.tpNF || dadosMovimento.tpNF || prev.tpNF || null,
                    natOp: dadosNfe.natOp || dadosMovimento.natOp || prev.natOp || '',
                    dhEmi: dadosNfe.dhEmi || dadosMovimento.dhEmi || prev.dhEmi || null,
                    dhSaiEnt: dadosNfe.dhSaiEnt || dadosMovimento.dhSaiEnt || prev.dhSaiEnt || null,

                    //valores do cabeçalho
                    vBC: valoresNfe.vBC || dadosMovimento.vBC || prev.vBC || 0,
                    vBCST: valoresNfe.vBCST || dadosMovimento.vBCST || prev.vBCST || 0,
                    vCOFINS: valoresNfe.vCOFINS || dadosMovimento.vCOFINS || prev.vCOFINS || 0,
                    vDesc: valoresNfe.vDesc || dadosMovimento.vDesc || prev.vDesc || 0,
                    vFrete: valoresNfe.vFrete || dadosMovimento.vFrete || prev.vFrete || 0,
                    vICMS: valoresNfe.vICMS || dadosMovimento.vICMS || prev.vICMS || 0,
                    vII: valoresNfe.vII || dadosMovimento.vII || prev.vII || 0,
                    vIPI: valoresNfe.vIPI || dadosMovimento.vIPI || prev.vIPI || 0,
                    vIPIDevol: valoresNfe.vIPIDevol || dadosMovimento.vIPIDevol || prev.vIPIDevol || 0,
                    vNF: valoresNfe.vNF || dadosMovimento.vNF || prev.vNF || 0,
                    vOutro: valoresNfe.vOutro || dadosMovimento.vOutro || prev.vOutro || 0,
                    vPIS: valoresNfe.vPIS || dadosMovimento.vPIS || prev.vPIS || 0,
                    vProd: valoresNfe.vProd || dadosMovimento.vProd || prev.vProd || 0,
                    vST: valoresNfe.vST || dadosMovimento.vST || prev.vST || 0,
                    vSeg: valoresNfe.vSeg || dadosMovimento.vSeg || prev.vSeg || 0,
                    vTotTrib: valoresNfe.vTotTrib || dadosMovimento.vTotTrib || prev.vTotTrib || 0,
                    valorDesconto: valoresNfe.valorDesconto || dadosMovimento.valorDesconto || prev.valorDesconto || 0,
                    valorFrete: valoresNfe.valorFrete || dadosMovimento.valorFrete || prev.valorFrete || 0,
                    valorNota: valoresNfe.valorNota || dadosMovimento.valorNota || prev.valorNota || 0,
                    valorProdutos: valoresNfe.valorProdutos || dadosMovimento.valorProdutos || prev.valorProdutos || 0,

                    //transporte
                    esp: transporte.esp || dadosMovimento.esp || prev.esp || '',
                    marca: transporte.marca || dadosMovimento.marca || prev.marca || '',
                    modFrete: transporte.modFrete || dadosMovimento.modFrete || prev.modFrete || '',
                    nVol: transporte.nVol || dadosMovimento.nVol || prev.nVol || '',
                    pesoB: transporte.pesoB || dadosMovimento.pesoB || prev.pesoB || '',
                    pesoL: transporte.pesoL || dadosMovimento.pesoL || prev.pesoL || '',
                    qVol: transporte.qVol || dadosMovimento.qVol || prev.qVol || '',

                    parceiroId: parceiro?.id || prev.parceiroId || null,

                    remetenteCEP: endEmit.CEP || '',
                    remetenteBairro: endEmit.xBairro || '',
                    remetenteLogradouro: endEmit.xLgr || '',
                    remetenteNumero: endEmit.nro || '',
                    remetenteComplemento: endEmit.xCpl || '',

                    destinatarioCEP: endDest.CEP || '',
                    destinatarioBairro: endDest.xBairro || '',
                    destinatarioLogradouro: endDest.xLgr || '',
                    destinatarioNumero: endDest.nro || '',
                    destinatarioComplemento: endDest.xCpl || '',

                    primeiraDataVencimento: cobranca?.dup?.dVenc || null,

                    preNotaXml: dadosPreNota,
                    xmlPossuiPendencia: dadosPreNota?.podeGravar === false,
                }));

                if (typeof onItensXmlLoaded === 'function') {
                    onItensXmlLoaded(dadosPreNota?.itens || []);
                }

                return true;
            } catch (error) {
                console.error(
                    'Erro ao aplicar documento fiscal ao Movimento:',

                    error
                );

                return false;
            }
        },
        [dados?.empresaId, setDados, setParceiro, onItensXmlLoaded, setFlashMessage]
    );

    const change = useCallback(
        (e, deps = {}) => {
            const { name, value, checked, type } = e?.target || {};

            if (!name) return;

            // suporta name="dados.campo" e name="campo"
            const campo = name.startsWith('dados.') ? name.split('.')[1] : name;

            // rotina para obter o xml da nota fiscal e preencher os campos do movimento, por isso o name pode ser "dados.campo" ou apenas "campo"
            if (campo === 'chNFe') {
                const chave = String(value || '')
                    .replace(/\D/g, '')
                    .slice(0, 44);

                setDados((prev) => ({
                    ...prev,
                    chNFe: chave,
                }));

                return;
            }

            const idFields = new Set([
                'empresaId',
                'situacaoId',
                'centroCustoId',
                'almoxarifadoId',
                'remetenteUfId',
                'remetenteMunicipioId',
            ]);

            // campos numéricos
            const numericFields = new Set(['caucao', 'multa', 'juros', 'valorComissao', 'descontoFinanceiro']);

            let nextValue = type === 'checkbox' ? checked : value;
            // helper: aplica update e retorna nextState
            const computeNext = (prev) => {
                const next = { ...prev, [campo]: nextValue };

                // exclusividade custo/custoFilial
                if (campo === 'custo' && nextValue === true) next.custoFilial = false;
                if (campo === 'custoFilial' && nextValue === true) next.custo = false;

                return next;
            };

            // 1) flags custo/custoFilial -> dispara evento (sem mexer em itens aqui)
            if (campo === 'custo' || campo === 'custoFilial') {
                const safeNext = computeNext(dados);

                setDados(safeNext);

                const flags = {
                    custo: !!safeNext.custo,
                    custoFilial: !!safeNext.custoFilial,
                };

                if (typeof deps.onFlagsChanged === 'function') {
                    deps.onFlagsChanged(flags, safeNext);
                }

                return;
            }

            // 2) parceiroId mudou -> dispara evento (ex.: atualizar parceiro)
            if (campo === 'parceiroId') {
                setDados((prev) => ({ ...prev, parceiroId: nextValue }));

                if (typeof deps.onParceiroChanged === 'function') {
                    deps.onParceiroChanged(nextValue);
                }
                return;
            }

            if (idFields.has(campo)) {
                nextValue = nextValue === '' || nextValue == null ? null : Number(nextValue);
            }
            if (numericFields.has(campo)) {
                nextValue = formatarNumeroDecimal(value);
            }

            setDados((prev) => ({
                ...prev,
                [campo]: nextValue,
            }));
        },
        [setDados, dados, profile]
    );

    /**
     * ✅ DATALIST: ADMINISTRADOR
     */
    const changeParceiroImovel = useCallback(async (value, deps = {}) => {
        return await handleParceiroImovelLookup(value, {
            ...deps,
            setTargetState: deps.setTargetState || setDados,
        });
    }, []);

    /**
     * ✅ DATALIST: COLABORADOR
     */
    const changeColaborador = useCallback(
        async (value, deps = {}) => {
            return await handleColaboradorLookup(value, {
                ...deps,
                setTargetState: deps.setTargetState || setDados,
                dataPlantao,
            });
        },
        [dataPlantao]
    );

    /**
     * ✅ DATALIST: PARCEIRO
     */
    const changeParceiro = useCallback(async (value, deps = {}) => {
        return await handleParceiroLookup(value, {
            ...deps,
            setTargetState: deps.setTargetState || setDados,
        });
    }, []);

    const verificarParceiroColaborador = useCallback(
        async (pessoaId, empresaId) => {
            if (!pessoaId) {
                return {
                    ehFuncionario: false,
                    podeUsarCusto: false,
                };
            }

            if (!profile?.parametros?.itens?.valorUnitarioIndexado) {
                return {
                    ehFuncionario: false,
                    podeUsarCusto: false,
                };
            }

            try {
                const resultado = await PessoaAPI.financeiro(pessoaId, empresaId);

                if (!resultado) {
                    return {
                        ehFuncionario: false,
                        podeUsarCusto: false,
                    };
                }

                const colaboradorAtivo = resultado?.pessoaColaborador?.ativo === true;
                const ehFuncionario = resultado?.funcionario === true && colaboradorAtivo;

                return {
                    ehFuncionario,
                    podeUsarCusto: ehFuncionario,
                    parceiroFinanceiro: resultado,
                };
            } catch (error) {
                console.error('Erro ao atualizar dados do parceiro:', error);

                return {
                    ehFuncionario: false,
                    podeUsarCusto: false,
                };
            }
        },
        [profile?.parametros?.itens?.valorUnitarioIndexado]
    );

    return {
        state: {
            dados,
            setDados,
        },
        actions: {
            change,
            aplicarDocumentoFiscal,
            clear,
            setRemote,
            changeParceiroImovel,
            changeColaborador,
            changeParceiro,
            verificarParceiroColaborador,
        },
    };
}
